export class BidMadeResponseModel {
    Id: number;
    CurrentBid: number;
    CurrentBidDateTime: Date;
    CurrentBidCustomerId: number;
    NextBid: number;

    Bids: number;
    Bidders: number;
    Watchers: number;
}